import React, { useId } from 'react';
type PapelPicadoProps = {
  count?: number;
  className?: string;
};
const fills = ['rgb(var(--color-verde))', 'rgb(var(--color-paper))', 'rgb(var(--color-salsa))'];
const fringe = 'M0 0 H40 V40 L36 46 L32 40 L28 46 L24 40 L20 46 L16 40 L12 46 L8 40 L4 46 L0 40 Z';
export function PapelPicado({
  count = 18,
  className = ''
}: PapelPicadoProps) {
  const uid = useId().replace(/:/g, '');
  return <div className={`relative w-full overflow-hidden ${className}`} aria-hidden="true" data-id="element-37" data-mp="1klofwpgkzt8v">
      <div className="absolute inset-x-0 top-1 h-px bg-ink/30" data-id="element-38" data-mp="1fmbu881g4s7v" />
      <div className="flex justify-between gap-1.5 px-1" data-id="element-39" data-mp="1fnvc232r3bbr">
        {Array.from({
        length: count
      }).map((_, i) => {
        const pattern = i % 3;
        const maskId = `pp-${uid}-${i}`;
        const isWhite = fills[i % 3] === fills[1];
        return <svg key={i} viewBox="0 0 40 46" className="h-10 w-9 shrink-0 sm:h-12 sm:w-10" style={{
          transform: `rotate(${i % 2 === 0 ? -2 : 2}deg)`
        }} data-id="element-40" data-mp="34yvs6xeihsrd" data-mpi={i}>
              <defs data-id="element-41" data-mp="5shkm8llqxpx">
                <mask id={maskId} data-id="element-42" data-mp="apgb8h624mjd">
                  <rect width="40" height="46" fill="white" data-id="element-43" data-mp="aof0kdsye226" />
                  {pattern === 0 && <>
                      <circle cx="20" cy="20" r="6" fill="black" data-id="element-44" data-mp="eruuh2dn1ob6" />
                      <path d="M20 6 L23 10 L20 14 L17 10 Z" fill="black" data-id="element-45" data-mp="jqefn0keqw2h" />
                      <path d="M20 26 L23 30 L20 34 L17 30 Z" fill="black" data-id="element-46" data-mp="3j5jl8tkn6nav" />
                      <path d="M6 20 L10 17 L14 20 L10 23 Z" fill="black" data-id="element-47" data-mp="3j3glvixlnhth" />
                      <path d="M26 20 L30 17 L34 20 L30 23 Z" fill="black" data-id="element-48" data-mp="3n74t20ibkbe7" />
                    </>}
                  {pattern === 1 && <>
                      <path d="M20 9 Q26 15 20 21 Q14 15 20 9 Z" fill="black" data-id="element-49" data-mp="s26vfxero7f" />
                      <path d="M20 21 Q26 27 20 33 Q14 27 20 21 Z" fill="black" data-id="element-50" data-mp="2zi2cyx3c2qlt" />
                      <circle cx="9" cy="10" r="2" fill="black" data-id="element-51" data-mp="34g3tba9dkbtl" />
                      <circle cx="31" cy="10" r="2" fill="black" data-id="element-52" data-mp="34eamnuyrhrll" />
                      <circle cx="9" cy="31" r="2" fill="black" data-id="element-53" data-mp="bklu277otiha" />
                      <circle cx="31" cy="31" r="2" fill="black" data-id="element-54" data-mp="6nby08psm8kh" />
                    </>}
                  {pattern === 2 && <>
                      <path d="M12 12 L28 12 L20 26 Z" fill="black" data-id="element-55" data-mp="kg1j8axhz9gj" />
                      <circle cx="20" cy="31" r="3" fill="black" data-id="element-56" data-mp="gd5815aaefmm" />
                      <circle cx="8" cy="22" r="2.2" fill="black" data-id="element-57" data-mp="3ornbetpa96zw" />
                      <circle cx="32" cy="22" r="2.2" fill="black" data-id="element-58" data-mp="3jtc16hv2suh5" />
                    </>}
                </mask>
              </defs>
              <path d={fringe} fill={fills[i % 3]} mask={`url(#${maskId})`} stroke={isWhite ? 'rgb(var(--color-line))' : 'none'} strokeWidth={isWhite ? 1 : 0} data-id="element-59" data-mp="1oihs8j4g3gm" />
            </svg>;
      })}
      </div>
    </div>;
}